  <template>
  <div class="row">
    <div class="col-12">
      {{$t('IMPERSONATE_BAR_TEXT', {userName: impersonatedUser.firstName, userLastName: impersonatedUser.lastName, email: impersonatedUser.email })}} <span
        v-t="{path: 'ACTION_IMPERSONATE_STOP'}"
        @click="stopImpersonating"
      ></span></div>

  </div>
</template>

<script>
export default {
  name: 'UserImpersonateBar',
  computed: {
    impersonatedUser () {
      return this.$store.getters['LoginStore/user']
    }
  },
  methods: {
    stopImpersonating () {
      this.$store.dispatch('LoginStore/stopImpersonation')
    }
  }
}
</script>

<style scoped>
div {
  background-color: lightgray;
  border: 1px solid gray;
}
span {
  margin: 0px 10px;
  font-weight: bold;
  text-decoration: underline;
  color: var(--text-heading);
  cursor: pointer;
}
</style>
